export function handleResponse(response, fullResponse) {
  if (![200, 202, 204].includes(response.status)) {
    return Promise.reject(fullResponse ? response : response.statusText);
  }

  return fullResponse ? response : response.data;
}

export function handleResponseLogin(response) {
  if (![200, 202, 204, 401].includes(response.status)) {
    return Promise.reject(response.statusText);
  }

  return {
    ...(response.data ?? {}),
    responseStatus: response.status,
  };
}

export function handleErrorLogin(response) {
  return Promise.reject(response.response);
}
